export default "__VITE_ASSET__ab1b213c__"